import clients from './pages/clients.json'
import contacts from './pages/contacts.json'
import dashboard from './pages/dashboard.json'
import invoices from './pages/invoices.json'
import projects from './pages/projects.json'
import projectToolbar from './pages/projectToolbar.json'
import proposals from './pages/proposals.json'
import offlineQuotes from './pages/offlineQuotes.json'
import purchaseorders from './pages/purchaseorders.json'
import projectChildren from './pages/projectChildren.json'
import login from './pages/Auth/login.json'
import errors from './pages/Auth/errors.json'
import forgotPassword from './pages/Auth/forgotPassword.json'
import newPassword from './pages/Auth/newPassword.json'
import signup from './pages/Auth/signup.json'
import purchases from './pages/purchases.json'
import QuoteGridPage1 from './pages/QuoteGridPage1.json'
import suppliers from './pages/suppliers.json'
import GridNavbar from './components/sections/GridNavbar/GridNavbar.json'
import OfflineButton from './components/sections/GridNavbar/OfflineButton.json'
import languages from './components/sections/Navbar/languages.json'
import settings from './components/sections/Navbar/settings.json'
import ProjectCard from './components/ui/Cards/ProjectCard.json'
import ClientDeleteDialog from './components/ui/Dialog/ClientDeleteDialog.json'
import ProjectDeleteDialog from './components/ui/Dialog/ProjectDeleteDialog.json'
import QuoteDeleteDialog from './components/ui/Dialog/QuoteDeleteDialog.json'
import QuoteDuplicateDialog from './components/ui/Dialog/QuoteDuplicateDialog.json'
import DeleteFreelancer from './components/ui/Dialog/DeleteFreelancer.json'
import QuoteMoveDialog from './components/ui/Dialog/QuoteMoveDialog.json'
import MenuDrawer from './components/ui/Drawer/MenuDrawer.json'
import quoteGrid from './components/ui/Grid/quoteGrid.json'
import RecapQuoteGrid from './components/ui/Grid/RecapQuoteGrid.json'
import QuoteHeader from './components/ui/Header/QuoteHeader.json'
import RecapQuoteHeader from './components/ui/Header/RecapQuoteHeader.json'
import EditQuoteMenu from './components/ui/Menu/EditQuoteMenu.json'
import SmgMenu from './components/ui/Menu/SmgMenu.json'
import SortMenu from './components/ui/Menu/SortMenu.json'
import AddQuoteFormModal from './components/ui/Modals/AddQuoteFormModal.json'
import ClientFormModal from './components/ui/Modals/ClientFormModal.json'
import ProjectFormModal from './components/ui/Modals/ProjectFormModal.json'
import QuoteSummaryModal from './components/ui/Modals/QuoteSummaryModal.json'
import RecapQuoteSummaryModal from './components/ui/Modals/RecapQuoteSummaryModal.json'
import InvoicePdf from './components/ui/Pdf/InvoicePdf.json'
import ProjectPdf from './components/ui/Pdf/ProjectPdf.json'
import QuotePdf from './components/ui/Pdf/QuotePdf.json'
import RecapQuotePdf from './components/ui/Pdf/RecapQuotePdf.json'
import SearchBar from './components/ui/SearchBar/SearchBar.json'
import QuoteToolbar from './components/ui/Toolbar/QuoteToolbar.json'
import RecapQuoteToolbar from './components/ui/Toolbar/RecapQuoteToolbar.json'
import CostLineNameFormatter from './utils/quoteGridUtils/CostLineNameFormatter.json'
import getPayrollTaxEnabledEditor from './utils/quoteGridUtils/getPayrollTaxEnabledEditor.json'
import getPayrollTaxTypesEditor from './utils/quoteGridUtils/getPayrollTaxTypesEditor.json'
import getUnitTypesEditor from './utils/quoteGridUtils/getUnitTypesEditor.json'
import OvertimeEditor from './utils/quoteGridUtils/OvertimeEditor.json'
import InvoiceDocumentEditor from './utils/recapGridUtils/InvoiceDocumentEditor.json'
import StatusCellEditor from './utils/recapGridUtils/StatusCellEditor.json'

const en = {
  clients,
  contacts,
  dashboard,
  invoices,
  projects,
  projectToolbar,
  proposals,
  offlineQuotes,
  purchaseorders,
  projectChildren,
  login,
  errors,
  forgotPassword,
  newPassword,
  signup,
  purchases,
  QuoteGridPage1,
  suppliers,
  GridNavbar,
  OfflineButton,
  languages,
  settings,
  ProjectCard,
  ClientDeleteDialog,
  ProjectDeleteDialog,
  QuoteDeleteDialog,
  QuoteDuplicateDialog,
  DeleteFreelancer,
  QuoteMoveDialog,
  MenuDrawer,
  quoteGrid,
  RecapQuoteGrid,
  QuoteHeader,
  RecapQuoteHeader,
  EditQuoteMenu,
  SmgMenu,
  SortMenu,
  AddQuoteFormModal,
  ClientFormModal,
  ProjectFormModal,
  QuoteSummaryModal,
  RecapQuoteSummaryModal,
  InvoicePdf,
  ProjectPdf,
  QuotePdf,
  RecapQuotePdf,
  SearchBar,
  QuoteToolbar,
  RecapQuoteToolbar,
  CostLineNameFormatter,
  getPayrollTaxEnabledEditor,
  getPayrollTaxTypesEditor,
  getUnitTypesEditor,
  OvertimeEditor,
  InvoiceDocumentEditor,
  StatusCellEditor,
}

export default en
